import requests from "./ajax";
import requestNew from "./ajax-new";

// 获取商品详情
export const getDetail= (data)=>{
  return requests.post('/shipping/Goods/ProductSearchQueryProductDetail', 
    data
  )
}

// 加入商品列表（刊登列表）
export const addShopList= (data)=>{
  return requests.post('/shipping/Order/addToGoodsList', 
    data
  )
}

// 加入购物车
export const addCartList= (data)=>{
  return requests.post('/shipping/Order/addToCart', 
    data
  )
}

// 获取类目
export const getCategory= (data)=>{
  return requests.post('/shipping/Category/CategoryTranslationGetById', 
    data
  )
}

// 获取推荐商品
export const getRecommend= (data)=>{
  return requests.post('/shipping/Goods/ProductSearchOfferRecommend', 
    data
  )
}

// 关键词搜索
export const searchKeyword= (data)=>{
  return requests.post('/shipping/Goods/ProductSearchKeywordQuery', 
    data
  )
}

// 上传图片
export const getImgId= (data)=>{
  return requests.post('/shipping/Goods/ProductImageUpload', 
    data
  )
}

// 图片搜索
export const searchImg= (data)=>{
  return requests.post('/shipping/Goods/ProductSearchImageQueryParam', 
    data
  )
}

// code获取用户信息
export const getInfo= (data)=>{
  return requests.post('/customer/api/polymerization/getUserInfoFromCode', 
    data
  )
}

// 获取汇率
export const getRate= (data)=>{
  return requests.post('/shipping/Order/getExchangeRate', 
    data
  )
}

// 获取国家下拉列表
export const getCountry= (data)=>{
  return requests.post('/customer/api/polymerization/get_sel', 
    data
  )
}

// 获取物流价格
export const getPrice=(data)=>{
  return requests.post('/customer/api/polymerization/get_logistics_price', 
    data
  )
}

// 获取西之月的运费
export const getWestPrice=(data)=>{
  return requests.post('/customer/api/polymerization/get_logistics_price', 
    data
  )
}

//  https://gsa.bi.gobizdev.com/item/get_weight
export const getWeght=(params)=>{
  return requests.get('https://gsa.bi.gobizdev.com/item/get_weight', 
    {params}
  )
}

// 获取默认国家
export const getDefault=(params)=>{
  return requests.get('/shipping/Order/getDefaultShippingToInfo', 
    {params}
  )
}

// 获取游客token
export const getTourists= (data)=>{
  return requests.post('/shipping/Tourists/login', 
    data
  )
}

// 获取传输方式信息
export const getTransport= (data)=>{
  return requests.post('/shipping/Order/getTransportTypeInfo', 
    data
  )
}

// 获取采购费
export const getPurchaseFee= (data)=>{
  return requests.post('/shipping/Order/getPurchaseFee', 
    data
  )
}

// 获取限时折扣产品
export const getDiscount= (data)=>{
  return requests.post('/shipping/Goods/DiscountProducts', 
    data
  )
}

// 包邮商品搜索
export const getInclude= (data)=>{
  return requests.post('/shipping/Goods/ShippingIncludedQuery', 
    data
  )
}

// 获取包邮分类
export const includeCategory=(params)=>{
  return requests.get('/shipping/Category/getShippingIncludedCategory', 
    {params}
  )
}

// 获取购物车列表
export const getCart = (data)=>requests.post('/shipping/Order/getCartList',data);

// 删除购物车商品
export const deleteCart = (data)=>requests.post('/shipping/Order/deleteCart',data);

// 设置购物车商品数量
export const editCart = (data)=>requests.post('/shipping/Order/setCartGoodsNum',data);

// 订单列表
export const orderList = (data)=>requests.post('/shipping/Order/list',data);

// 获取订单信息
export const orderDetails = (data)=>requests.post('/shipping/Order/info',data);

// 取消订单信息
export const candelOrder = (data)=>requests.post('/shipping/Order/cancel',data);

// 订单信息预览
export const orderInfo = (data)=>requests.post('/shipping/Order/preview',data);

// 创建订单
export const orderCreate = (data)=>requests.post('/shipping/Order/create',data);

// 获取物流价格
export const getLogisPrice = (data)=>requests.post('/customer/api/polymerization/get_logistics_price',data);

// 订单支付
export const orderPay = (data)=>requests.post('/shipping/Order/pay',data);

// 订单支付状态同步
export const paymentStatus = (data)=>requests.post('/shipping/Order/orderPaymentSync',data);

// 一美元商品
export const oneUsd = (data)=>requests.post('/shipping/Goods/OneUsdQuery',data);

// 获取搜索历史记录
export const queryHistory=(params)=>{
  return requests.get('/shipping/Goods/getQueryHistory', 
    {params}
  )
}

// 清除搜索历史记录
export const clearHistory=(data)=>{
  return requests.post('/shipping/Goods/clearQueryHistory', 
    data
  )
}

// 获取商品专区列表
export const getSpecialArea=(params)=>{
  return requests.get('/shipping/Goods/GoodsSpecialAreaClassList', 
    {params}
  )
}

// 获取专区商品列表
export const getSpecialList=(params)=>{
  return requests.get('/shipping/Goods/GoodsSpecialAreaList', 
    {params}
  )
}

// 获取追踪
export const getTracking = (data)=>requests.post('/shipping/Order/tracking',data);


// 获取优惠卷
export const receiveCoupon = (data)=>requests.post('/shipping/Order/receiveCoupon',data);

// 优惠卷是否领取
export const getActInfo = (data)=>requests.post('/shipping/Order/getUserInfo',data);

// 优惠卷是否领取
export const getSearchKeywordS = (data)=>requests.post('/shipping/Goods/ProductSearchKeywordSNQuery',data);

// 获取西之月所有证书
export const getXiYueCertificates=(params)=>{
  return requests.get('/shipping/Goods/getXiYueCertificates', 
    {params}
  )
}

// 获取西之月发货国家
export const getXiYueDeliveryRegions=(params)=>{
  return requests.get('/shipping/Goods/getXiYueDeliveryRegions', 
    {params}
  )
}

// 获取西之月分类
export const getXiYueCategory=(params)=>{
  return requests.get('/shipping/Goods/getXiYueCategory', 
    {params}
  )
}

// 获取1688类目
export const getZoneGoodsCategory= (data)=>{
  return requests.post('/shipping/Category/getZoneGoodsCategory', 
    data
  )
}

// 国际站商品推荐
export const commodityRecommendation=(params)=>{
  return requests.get('/shipping/Goods/commodityRecommendation', 
    {params}
  )
}

// 国际站类别列表
export const getProductCategoryList=(params)=>{
  return requests.get('/shipping/Goods/getProductCategoryList', 
    {params}
  )
}

// 国际站商品列表
export const getCommodityList=(params)=>{
  return requests.get('/shipping/Goods/getCommodityList', 
    {params}
  )
}

// 国际站上传图片
export const getEcoBuyerItemAdd= (data)=>{
  return requests.post('/shipping/Goods/EcoBuyerItemAdd', 
    data
  )
}

// 国际站图片搜索
export const getBuyerItemRecImageList= (data)=>{
  return requests.post('/shipping/Goods/getBuyerItemRecImageList', 
    data
  )
}

// 首页商品搜索
export const getProductSearchList=(params)=>{
  return requests.get('/shipping/Goods/getProductSearchList', 
    {params}
  )
}

// 关键词推荐
export const getKeywordRecommendation=(params)=>{
  return requests.get('/shipping/Goods/getKeywordRecommendation', 
    {params}
  )
}

// 根据商品推荐相关性商品
export const getProductRelatedRecommend= (data)=>{
  return requests.post('/shipping/Goods/getProductRelatedRecommend', 
    data
  )
}

// 首页推荐商品列表
export const getProductSearchOfferRecommendHandle= (data)=>{
  return requests.post('/shipping/Goods/getProductSearchOfferRecommendHandle', 
    data
  )
}

// 根据用户搜索推荐产品
export const getHistoricalRecordRecommendations= (data)=>{
  return requests.post('/shipping/Goods/getHistoricalRecordRecommendations', 
    data
  )
}

// 解析推广文本并获取商品ID
export const parsePromotionText=(params)=>{
  return requestNew.get('/mall/parsePromotionText', 
    {params}
  )
}

// 获取DDP/DDU Freight各一条
export const getFreightList= (data)=>{
  return requests.post('/shipping/Order/getDdpDduFreightList', 
    data
  )
}

// 首页商品搜索
export const getProductSearchLists=(params)=>{
  return requestNew.get('/mall/getProductSearchList', 
    {params}
  )
}

// 修改国际站运费代码
export const updateFreightCode= (data)=>{
  return requests.post('/shipping/Order/updateFreightCode', 
    data
  )
}

// 抽奖接口 - 获取中奖信息
export const getLotteryResult = (data)=>{
  return requestNew.post('/lottery/doLottery', 
    data
  )
}

// 抽奖接口 - 获取抽奖机会
export const addLotteryCount = (data)=>{
  return requestNew.post('/lottery/addLotteryCount', 
    data
  )
}

// 抽奖接口 - 活动信息
export const getLotteryInfo = (params)=>{
  return requestNew.get(`/lottery/getActivity`, 
    {params}
  )
}

// 抽奖接口 - 抽奖记录
export const getAllRecords = (params)=>{
  return requestNew.get('/lottery/getAllWinningRecords', 
    {params}
  )
}

// 抽奖接口 - 所有实物中奖记录
export const getAllPhysicalRecords = (params)=>{
  return requestNew.get('/lottery/getAllPhysicalWinningRecords', 
    {params}
  )
}

// 填写实物奖品的地址信息 lottery/exchangePrize
export const exchangePrize = (data)=>{
  return requestNew.post('/lottery/exchangePrize', 
    data
  )
}



export const getWinningRecords = (params)=>{
  return requestNew.get('/lottery/getWinningRecords', 
    {params}
  )
}

// 出库申请详情
export const outboundDetial= (data)=>{
  return requests.post('/shipping/Order/submitForOutboundReleaseParticulars', 
    data
  )
}

// 出库申请
export const submitOutbound= (data)=>{
  return requests.post('/shipping/Order/submitForOutboundRelease', 
    data
  )
}

// 库存详情
export const getDetailsOfGoodsWarehousing= (data)=>{
  return requests.post('/shipping/Order/getDetailsOfGoodsWarehousing', 
    data
  )
}

// 热销商品分类
export const getSpecialAreaCategoryList= (data)=>{
  return requests.post('/shipping/goods/getSpecialAreaCategoryList', 
    data
  )
}